import Difference from './deepObjectDifference';
import { decompressedConfigObj } from './itemPayloadDifferConfig';

export const itemPayloadDifferConfig = decompressedConfigObj;

export default Difference;
